import server from "@/api/server";

async function login(data) {
  let res = await server.post("/account/login", data, {
    dontLog: true
  });
  return res;
}

async function logout() {
  let res = await server.get("/account/logout");
  return res;
}

async function initRecovery(phone) {
  let res = await server.post("/agent/ext/recovery/init", { phone });
  return res;
}

async function confirmRecovery(smsid, code) {
  let res = await server.post("/agent/ext/recovery/confirm", { smsid, code });
  return res;
}

async function refreshRecovery(phone) {
  let res = await server.post("/agent/ext/recovery/refresh", { phone });
  return res;
}

async function recovery(smsid, pass) {
  let res = await server.post("account/recovery", { smsid, pass });
  return res;
}

export { login, logout, initRecovery, confirmRecovery, refreshRecovery, recovery };
